<template>
    <div class="projectExperience">
        <div class="main">
            <p class="title">项目经验
                <span class="add"
                      @click="interactive('ruleForm')">
                    <i class="el-icon-plus"></i>添加
                </span>
            </p>
            <div class="mould"
                 v-for="(item,index) in projectList"
                 :key="index">
                <p>{{item.projectName}}<span>{{item.projectStart|formatDate}}-{{item.projectEnd|formatDate}}
                        <el-button v-show="!buttonshow"
                                   style="margin-left:20px;"
                                   type="text"
                                   @click="edit(index)">编辑</el-button>
                        <el-button v-show="!buttonshow"
                                   type="text"
                                   @click="open(index)">删除</el-button>
                        <el-button v-show="buttonshow"
                                   style="margin-left:20px;"
                                   type="text"
                                   @click="editthis(item.id,index)">编辑该项</el-button>
                        <el-button v-show="buttonshow"
                                   type="text"
                                   @click="openthis(item.id)">删除该项</el-button>
                    </span></p>
                <p>{{item.roleName}}</p>
                <div class="entry"
                     style="white-space:pre-line">
                    {{item.description}}
                </div>
            </div>
            <el-form v-show="showed"
                     :model="ruleForm"
                     :rules="rules"
                     ref="ruleForm"
                     :inline="true"
                     label-position="top"
                     label-width="100px"
                     class="demo-ruleForm">
                <h3>编辑项目经验:</h3>
                <el-form-item label="项目名称"
                              prop="projectName">
                    <el-input maxlength="30"
                              v-model="ruleForm.projectName"></el-input>
                </el-form-item>
                <el-form-item label="担任角色"
                              prop="roleName">
                    <el-input maxlength="30"
                              v-model="ruleForm.roleName"></el-input>
                </el-form-item>
                <el-form-item label="在职时间"
                              prop="projectStart">
                    <el-date-picker v-model="ruleForm.projectStart"
                                    :clearable="false"
                                    type="date"
                                    @change="changeendstartDate"
                                    placeholder="开始时间">
                    </el-date-picker>
                    <el-form-item label=""
                                  prop="projectEnd">
                        <el-date-picker style="margin-left:10px;"
                                        v-model="ruleForm.projectEnd"
                                        :clearable="false"
                                        @change="changeendDate"
                                        type="date"
                                        placeholder="结束时间">
                        </el-date-picker>
                    </el-form-item>
                </el-form-item>

                <el-form-item label="项目描述"
                              prop="description">
                    <el-input type="textarea"
                              maxlength="500"
                              v-model="ruleForm.description"></el-input>
                </el-form-item>
                <el-form-item v-show="!buttonshow"
                              class="center">
                    <el-button type="primary"
                               @click="subit('ruleForm')">保存</el-button>
                    <el-button @click="rest('ruleForm')">取消</el-button>
                </el-form-item>
                <el-form-item v-show="buttonshow"
                              class="center">
                    <el-button type="primary"
                               @click="subitsaveeprojectexperience('ruleForm')">确认</el-button>
                    <el-button @click="restsaveeprojectexperience('ruleForm')">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import {
    saveprojectexperience,
    selectprojectexperience,
    delectprojectexperience
} from "@/api/apiall";
export default {
    data() {
        return {
            buttonshow: false,
            number: 999,
            projectList: [],
            showed: false,
            ruleForm: {
                id: "",
                personId: "",
                projectName: "",
                roleName: "",
                projectStart: "",
                projectEnd: "",
                description: ""
            },
            rules: {
                projectName: [
                    {
                        required: true,
                        message: "请输入项目名称",
                        trigger: "blur"
                    }
                ],
                roleName: [
                    {
                        required: true,
                        message: "请输入担任角色",
                        trigger: "blur"
                    }
                ],
                projectStart: [
                    {
                        required: true,
                        message: "请输入开始时间",
                        trigger: "blur"
                    }
                ],
                projectEnd: [
                    {
                        required: true,
                        message: "请输入结束时间",
                        trigger: "blur"
                    }
                ],
                description: [
                    {
                        required: true,
                        message: "请输入项目描述",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    watch: {
        $route(to, from) {
            if (to.path == "/Curriculumvitae") {
                this.buttonshow = true;
            } else {
                this.buttonshow = false;
            }
        }
    },
    created() {
        if (this.$route.path == "/Curriculumvitae") {
            this.buttonshow = true;
        } else {
            this.buttonshow = false;
        }
        // if (
        //     sessionStorage.getItem("userId") != null ||
        //     sessionStorage.getItem("userId") != undefined
        // ) {
        //     this.searchselectprojectexperience();
        // }
    },
    mounted() {},
    methods: {
        searchselectprojectexperience() {
            this.ruleForm.personId = sessionStorage.getItem("informationId");
            selectprojectexperience({ personId: this.ruleForm.personId }).then(
                res => {
                    if (res.status === 2000) {
                        this.projectList = res.data;
                    }
                }
            );
        },
        changeendstartDate() {
            if (this.ruleForm.projectStart > this.ruleForm.projectEnd) {
                this.ruleForm.projectEnd = "";
            }
        },
        changeendDate() {
            if (this.ruleForm.projectStart > this.ruleForm.projectEnd) {
                this.ruleForm.projectEnd = "";
                this.$message({
                    type: "warning",
                    message: "结束时间必须大于开始时间!"
                });
            }
        },
        edit(index) {
            this.showed = true;
            this.number = index;
            this.ruleForm = { ...this.projectList[index] };
        },
        editthis(item, index) {
            debugger;
            this.showed = true;
            this.number = index;
            this.ruleForm = { ...this.projectList[index] };
        },
        openthis(item) {
            this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                delectprojectexperience({ id: item }).then(res => {
                    if (res.status === 2000) {
                        this.$message({
                            message: "删除成功",
                            type: "success"
                        });
                        this.searchselectprojectexperience();
                    }
                });
            });
        },
        open(index) {
            this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.del(index);
                this.$message({
                    type: "success",
                    message: "删除成功!"
                });
            });
        },
        del(index) {
            this.projectList.splice(index, 1);
        },
        interactive(formName) {
            this.ruleForm.id = "";
            this.number = 999;
            if (this.projectList.length < 10) {
                this.showed = true;
                this.$refs[formName].clearValidate();
            } else {
                this.$message({
                    message: "最多添加10条",
                    type: "warning"
                });
            }
        },
        subitsaveeprojectexperience(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.ruleForm.personId = sessionStorage.getItem(
                        "informationId"
                    );
                    saveprojectexperience(this.ruleForm).then(res => {
                        if (res.status === 2000) {
                            this.$message({
                                message: "提交成功",
                                type: "success"
                            });
                            this.ruleForm = {};
                            this.$refs[formName].clearValidate();
                            this.showed = false;
                            this.searchselectprojectexperience();
                        } else {
                            this.$message({
                                message: res.data,
                                type: "warning"
                            });
                        }
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        restsaveeprojectexperience(formName) {
            this.$refs[formName].resetFields();
            this.showed = false;
        },
        subit(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    if (this.number != 999) {
                        this.projectList[this.number] = this.ruleForm;
                    } else {
                        this.projectList.push(this.ruleForm);
                    }
                    this.ruleForm = {};
                    this.$refs[formName].clearValidate();
                    this.showed = false;
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        rest(formName) {
            this.ruleForm = {};
            this.showed = false;
        },
        save() {
            this.$emit("projectExperienceByValue", this.projectList);
        }
    }
};
</script>
<style scoped lang="scss">
.projectExperience {
    width: 900px;
    background-color: #fff;
    float: left;
    .mould {
        p {
            margin-top: 20px;
            font-size: 15px;
            span {
                float: right;
                color: #666;
            }
        }
        .entry {
            font-size: 14px;
            color: #666;
            line-height: 26px;
            word-wrap: break-word;
            word-break: break-all;
        }
    }
    .main {
        padding: 30px;
        border-bottom: 1px solid #ddd;
        .title {
            font-size: 18px;
            color: #333;
            .add {
                cursor: pointer;
                float: right;
                color: #fabe00;
                font-size: 15px;
            }
        }
        .sign {
            display: inline-block;
            margin-left: 12px;
            position: relative;
            top: -2px;
            width: 37px;
            height: 18px;
            color: #fff;
            background-color: #fabe00;
            text-align: center;
            line-height: 16px;
            font-size: 12px;
            border-radius: 4px;
        }
        .el-form {
            margin-top: 20px;
            margin-bottom: 20px;
            .el-input,
            .el-select {
                width: 230px;
            }
            h3 {
                font-size: 17px;
                margin: 20px 0;
                font-weight: 500;
            }
            .el-date-editor {
                width: 120px;
                /deep/ .el-input__inner {
                    padding-right: 0;
                }
            }
            .el-textarea {
                width: 740px;
            }
            /deep/ .el-form-item {
                margin-bottom: 6px !important;
                .el-form-item__label {
                    padding: 0 !important;
                }
            }
        }
        .el-form--label-top .el-form-item__label {
            padding: 0;
        }
        .el-form--inline .el-form-item {
            margin-right: 30px;
        }
        .center {
            position: relative;
            left: 50%;
            transform: translateX(-50%);
            margin-top: 30px;
        }
    }
}
</style>
